import { useSetCurrentWorkspace } from '../../auth';
import { Workspace } from '../domain';

export const useImpersonateWorkspace = () => {
  const { mutateAsync: setCurrentWorkspace } = useSetCurrentWorkspace();

  const impersonateWorkspace = async (workspace?: Workspace) => {
    await setCurrentWorkspace(
      workspace ? JSON.stringify(workspace) : undefined
    );
  };

  return {
    impersonateWorkspace,
  };
};
